import * as React from 'react';
import {Button} from "react-bootstrap";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";

const DownloadsScreen = ({history, language, t}) => {
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const [downloadLink, setDownloadLink] = useState('https://smadify.api.bravo-gw.sigmanet.cloud/api/downloads/');
    //const [downloadLink, setDownloadLink] = useState('http://localhost:5000/api/downloads/');
    //const baseUrl = 'http://localhost:5000/api/downloads/';
    const baseUrl = 'https://smadify.api.bravo-gw.sigmanet.cloud/api/downloads/';
    const [buttonVisible, setButtonVisible] = useState(false);

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
        else {
            setDownloadLink(baseUrl + userInfo._id);
            setButtonVisible(true);
        }
    }, [userInfo, history]);

/*    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);*/
    const style = {color: 'black'};

    return (
        <div>
            <p style={style}>{t('downloads_instruction_not_installed')}</p>
            <p>
                <ul>
                    <li  style={style}>{t('downloads_instruction_not_installed_1')}</li>
                    <li  style={style}>{t('downloads_instruction_not_installed_2')}</li>
                    <li  style={style}>{t('downloads_instruction_not_installed_3')}</li>
                </ul>
            </p>

            <p  style={style}>{t('downloads_instruction_installed')}</p>
            <p  style={style} className={'mb-4'}>
                <ul>
                    <li  style={style}>{t('downloads_instruction_installed_1')}</li>
                    <li  style={style}>{t('downloads_instruction_installed_2')}</li>
                    <li  style={style}>{t('downloads_instruction_installed_3')}</li>
                </ul>
            </p>

            {buttonVisible ? (<div>
                <p style={style} className={'mb-1'}>{t('downloads_download_link')}</p>
                <p style={style} className={'text-danger mb-4'}>{downloadLink}</p>
            </div>) : (<div></div>)}

            <Button disabled={!buttonVisible} variant='info' rel="noopener noreferrer" target="_blank" href={downloadLink}>{t('button_download')}</Button>
        </div>
    );
};

export default DownloadsScreen;
